import config from "../config"
const baseUrl = config.base_url + "container_farm_work_scheme/"
export default {
    list: {
        url:  baseUrl + "list",
        type: "get",
    },
    page: {
        url:  baseUrl + "page/{limit}/{page}",
        type: "get",
    },
    remove:{
        url:  baseUrl + "delete",
        type: "get",
    },
    save:{
        url:  baseUrl + "save",
        type: "post",
    },
    get:{
        url:  baseUrl + "get",
        type: "get",
    },
    listByContainer:{
        url:  baseUrl + "listByContainer",
        type: "get",
    }
}
